import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LoadingPage } from "../components/Loading";

/** Signed in and approved by an organization admin. */
export const RequireAuth: React.FC = () => {
  const { user, approved, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingPage />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (!approved) return <Navigate to="/waiting-approval" replace />;

  return <Outlet />;
};

/** Nested inside RequireAuth, so authentication is already guaranteed here. */
export const RequireAdmin: React.FC = () => {
  const { isAdmin, loading } = useAuth();

  if (loading) return <LoadingPage />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
};
